<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Business EPayment",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Business EPayment",
            items: [
               {
                  text: "Businesses",
                  href: "/customers",
               },
               {
                  text: "Vehicles",
                  href: "/vehicles",
               },
               {
                  text: "Add EPayment",
                  active: true,
               },        
            ],

            contact_id: null,
            vehicle_id: null,

            epayment: {
               vehicle_id: '',
               service_id: '',               
               payment_mode: '',
               party_receipt: '',
               agency_payment_mode: '',
               agency_receipt: '',
               premium_cost: '',
               client_paid_amount: '',
               transfer_amount: '',
               remarks: '',
               epayment_expiry: '',
               attachment: '',
            },

            services: [],  
            epayment_services: [],          

            modes: [
               {id: 1, mode: 'Cash'},
               {id: 2, mode: 'Credit'},
               {id: 3, mode: 'Online'},
            ],

            vehicle: {},
            states: [],           
            brands: [],
            models: [],
            rtos: [],
            fuel_types: [],
            hypothecations: [],
            gvws: [],

            token: '',
            errors: {},


         };
      },
      mounted() {
         this.contact_id = this.$route.params.contact_id;
         this.vehicle_id = this.$route.params.vehicle_id;

         this.fetchVehicleDetails();
         this.fetchVehicleDropDowns(); 

         this.fetchServices();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         alphaDotSpacesOnly(event) {
         let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32) || (keyCode == 46))  {
                  return;
            } else {
               event.preventDefault();
            }
         },

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },      

         fetchVehicleDropDowns() {
            let url = "/api/hub/contacts/details?type=2";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  //console.log(res);
                  var responseData = res.data.data;
                  this.brands = responseData.brands;
                  this.hypothecations = responseData.hypothecations;
                  this.fuel_types = responseData.fuel_types;
                  this.gvws = responseData.gvw;
                  this.states = responseData.states;

                  this.fetchModels();
                  this.fetchRTOs();
               })
               .catch((err) => console.log(err));
         },

         fetchModels() {
            let url = "/api/hub/contacts/getModels?type=2&brand_id=" + this.vehicle.brand_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.models = responseData.models;
               })
               .catch((err) => console.log(err));
         },

         fetchRTOs() {
            let url = "/api/hub/contacts/getRTO?type=2&state_id=" + this.vehicle.state_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.rtos = responseData.rto;
               })
               .catch((err) => console.log(err));
         },     

         fetchVehicleDetails() {
            let url = "api/hub/contacts/vehicles/details?id=" + this.vehicle_id;
            
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.vehicle = responseData.details;
               
               })
            .catch((err) => console.log(err));
         }, 

         fetchServices() {
            let url = "/api/hub/contacts/services";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  //console.log(res);
                  var responseData = res.data.data;
                  this.services = responseData.services;

                  for(var j = 0; j < this.services.length; j++) {
                     if(this.services[j].epayment == 1) {
                        this.epayment_services.push(this.services[j]);
                     }
                  }

                  //console.log(this.epayment_services);

            })
            .catch((err) => console.log(err));
         }, 

         setFile(event) {
            this.epayment.attachment = event.target.files[0];
            //this.preview_image = URL.createObjectURL(this.epayment.attachment);     
         },        

         addEPayment() {
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            if(this.vehicle.vehicle_type == 2) {
               this.vehicle.carrier_type = '';
            }

            let formData = new FormData();
            formData.append("vehicle_id", this.vehicle_id); 
            formData.append("vehicle_number", this.vehicle.vehicle_number);
            formData.append("manufacturer", this.vehicle.manufacturer);
            formData.append("vehicle_type", this.vehicle.vehicle_type);
            formData.append("carrier_type", this.vehicle.carrier_type);
            formData.append("model_id", this.vehicle.model_id);
            formData.append("fuel_type_id", this.vehicle.fuel_type_id);
            formData.append("gvw_id", this.vehicle.gvw_id);
            formData.append("cubic_capacity", this.vehicle.cubic_capacity);
            //formData.append("hypothecation_id", this.vehicle.hypothecation_id);
            formData.append("rto_id", this.vehicle.rto_id);

            formData.append("service_id", this.epayment.service_id);            
            formData.append("payment_mode", this.epayment.payment_mode);
            formData.append("party_receipt", this.epayment.party_receipt);
            formData.append("agency_payment_mode", this.epayment.agency_payment_mode);
            formData.append("agency_receipt", this.epayment.agency_receipt);
            formData.append("premium_cost", this.epayment.premium_cost);
            formData.append("client_paid_amount", this.epayment.client_paid_amount);
            formData.append("transfer_amount", this.epayment.transfer_amount);
            formData.append("remarks", this.epayment.remarks);
            formData.append("epayment_expiry", this.epayment.epayment_expiry);
            formData.append("attachment", this.epayment.attachment);

            if(!this.vehicle.hypothecation_id) {
               formData.append("hypothecation_id", "");
            }

           

            this.loading = true;            
            this.errors = {};
            this.$axios
               .post("/api/hub/contacts/createPayment", formData, config)
               .then((response) => {
                  //console.log(response);
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     
                  } else {
                     this.$swal("", response.data.message, "error");
                  }

                  this.$router.push({ name: 'customers.vehicles', params: { id: this.contact_id } });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(!this.vehicle.brand_id) {
                           this.errors['brand_id'] = [];
                           this.errors['brand_id'][0] = "Please select a brand";
                        }
                        if(!this.vehicle.state_id) {
                           this.errors['state_id'] = [];
                           this.errors['state_id'][0] = "Please select a state";
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <!-- <router-link :to="{ name: 'customers.vehicles', params: { id: contact_id }  }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <form class="form-horizontal" role="form" @submit.prevent="addEPayment()">
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                        <h4 class="card-title mb-3">Vehicle Details</h4>
                     
                        <div class="row"> 

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Vehicle No. <span class="text-danger">*</span></label>
                              <b-form-input v-model="vehicle.vehicle_number" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_number) }"></b-form-input>
                              <div v-for="(val, index) in errors.vehicle_number" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Manufacture Year <span class="text-danger">*</span></label>
                              <b-form-input v-model="vehicle.manufacturer" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.manufacturer) }" @keypress="numbersOnly"></b-form-input>
                              <div v-for="(val, index) in errors.manufacturer" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                           

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Vehicle Type <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.vehicle_type" v-bind:class="{ 'is-invalid': Boolean(errors.vehicle_type) }" @change="vehicle.carrier_type=null">
                                 <option :value="null" v-if="!vehicle.vehicle_type">Select Vehicle Type</option>
                                 <option value="1">Taxi</option>
                                 <option value="2">Private</option>
                              </select>
                              <div v-for="(val, index) in errors.vehicle_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3" v-if="vehicle.vehicle_type==1">
                              <label>Carrier Type <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.carrier_type" v-bind:class="{ 'is-invalid': Boolean(errors.carrier_type) }">
                                 <option :value="null">Select Carrier Type</option>
                                 <option value="1">Passenger</option>
                                 <option value="2">Carrier</option>
                              </select>

                              <div v-for="(val, index) in errors.carrier_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Brand <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.brand_id" @change="fetchModels(), vehicle.model_id=null" v-bind:class="{ 'is-invalid': Boolean(errors.brand_id) }">
                                 <option v-if="!vehicle.brand_id" :value="null">Select Brand</option>
                                 <option :value="brand.id" v-for="brand in brands" :key="brand.id">{{brand.brand}}</option>
                              </select>

                              <div v-for="(val, index) in errors.brand_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3" v-if="vehicle.brand_id">
                              <label>Model <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.model_id" v-bind:class="{ 'is-invalid': Boolean(errors.model_id) }">
                                 <option :value="null" v-if="!vehicle.model_id">Select Model</option>
                                 <option :value="model.id" v-for="model in models" :key="model.id">{{model.model}}</option>
                              </select>

                              <div v-for="(val, index) in errors.model_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Fuel Type <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.fuel_type_id" v-bind:class="{ 'is-invalid': Boolean(errors.fuel_type_id) }">
                                 <option :value="null" v-if="!vehicle.fuel_type_id">Select Fuel Type</option>         
                                 <option :value="fuel_type.id" v-for="fuel_type in fuel_types" :key="fuel_type.id">{{fuel_type.fuel_type}}</option>
                              </select>

                              <div v-for="(val, index) in errors.fuel_type_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Cubic Capacity (CC) <span class="text-danger">*</span></label>
                              <b-form-input v-model="vehicle.cubic_capacity" v-bind:class="{ 'is-invalid': Boolean(errors.cubic_capacity) }"></b-form-input>

                              <div v-for="(val, index) in errors.cubic_capacity" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>  

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Hypothecation <span class="text-danger">*</span></label>                              
                              <select class="form-control" v-model="vehicle.hypothecation_id" v-bind:class="{ 'is-invalid': Boolean(errors.hypothecation_id) }">
                                 <option :value="null">None</option>
                                 <option :value="hypothecation.id" v-for="hypothecation in hypothecations" :key="hypothecation.id">{{hypothecation.hypothecation}}</option>
                              </select>

                              <div v-for="(val, index) in errors.hypothecation_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>  

                           <b-form-group class="col-lg-4 mb-3">
                              <label>State <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.state_id" v-bind:class="{ 'is-invalid': Boolean(errors.state_id) }" @change="fetchRTOs(), vehicle.rto_id=null">
                                 <option :value="null" v-if="!vehicle.state_id">Select State</option>
                                 <option :value="state.id" v-for="state in states" :key="state.id">{{state.state}}</option>
                              </select>

                              <div v-for="(val, index) in errors.state_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3" v-if="vehicle.state_id">
                              <label>RTO <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.rto_id" v-bind:class="{ 'is-invalid': Boolean(errors.rto_id) }">
                                 <option :value="null" v-if="!vehicle.rto_id">Select RTO</option>
                                 <option :value="rto.id" v-for="rto in rtos" :key="rto.id">{{rto.rto}}</option>
                              </select>

                              <div v-for="(val, index) in errors.rto_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>  

                           <b-form-group class="col-lg-4 mb-3">
                              <label>GVW <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="vehicle.gvw_id" v-bind:class="{ 'is-invalid': Boolean(errors.gvw_id) }">
                                 <option :value="null" v-if="!vehicle.gvw_id">Select GVW</option>
                                 <option :value="gvw.id" v-for="gvw in gvws" :key="gvw.id">{{gvw.gvw}}</option>
                              </select>

                              <div v-for="(val, index) in errors.gvw_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                                                    
                        </div>

                     </b-card>
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                     
                        <div class="row">                            

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Service <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="epayment.service_id" v-bind:class="{ 'is-invalid': Boolean(errors.service_id) }">
                                 <option value="">Select Service</option>
                                 <option :value="service.id" v-for="service in epayment_services" :key="service.id">
                                    <span>{{service.service}}</span>
                                 </option>
                              </select>

                              <div v-for="(val, index) in errors.service_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Govt/ Agency Payment Mode <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="epayment.agency_payment_mode" v-bind:class="{ 'is-invalid': Boolean(errors.agency_payment_mode) }">
                                 <option value="">Select Agency Payment Mode</option>
                                 <option :value="mode.id" v-for="mode in modes" :key="mode.id">{{mode.mode}}</option>
                              </select>

                              <div v-for="(val, index) in errors.agency_payment_mode" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Govt/ Agency UTR Number</label>
                              <b-form-input  v-model="epayment.agency_receipt" v-bind:class="{ 'is-invalid': Boolean(errors.agency_receipt) }" maxlength="30"></b-form-input>

                              <div v-for="(val, index) in errors.agency_receipt" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Customer Payment Mode <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="epayment.payment_mode" v-bind:class="{ 'is-invalid': Boolean(errors.payment_mode) }">
                                 <option value="">Select Payment Mode</option>
                                 <option :value="mode.id" v-for="mode in modes" :key="mode.id">{{mode.mode}}</option>
                              </select>

                              <div v-for="(val, index) in errors.payment_mode" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Customer Receipt/ UTR Number</label>
                              <b-form-input v-model="epayment.party_receipt" v-bind:class="{ 'is-invalid': Boolean(errors.party_receipt) }" maxlength="30"></b-form-input>

                              <div v-for="(val, index) in errors.party_receipt" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Customer Paid Amount <span class="text-danger">*</span></label>
                              <b-input-group size="sm" prepend="Rs.">
                                 <b-form-input type="number" step="any" v-model="epayment.client_paid_amount"  v-bind:class="{ 'is-invalid': Boolean(errors.client_paid_amount) }"></b-form-input>
                              </b-input-group>

                              <div v-for="(val, index) in errors.client_paid_amount" :key="index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Govt Fees <span class="text-danger">*</span></label>
                              <b-input-group size="sm" prepend="Rs.">
                                 <b-form-input type="number" step="any" v-model="epayment.premium_cost"  v-bind:class="{ 'is-invalid': Boolean(errors.premium_cost) }"></b-form-input>
                              </b-input-group>

                              <div v-for="(val, index) in errors.premium_cost" :key="index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                           

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Transferred Amount to Govt/ Agency <span class="text-danger">*</span></label>
                              <b-input-group size="sm" prepend="Rs.">
                                 <b-form-input type="number" step="any" v-model="epayment.transfer_amount"  v-bind:class="{ 'is-invalid': Boolean(errors.transfer_amount) }"></b-form-input>
                              </b-input-group>

                              <div v-for="(val, index) in errors.transfer_amount" :key="index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                           

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Next Renewal Date</label>
                              <b-form-input type="date" v-model="epayment.epayment_expiry" v-bind:class="{ 'is-invalid': Boolean(errors.epayment_expiry) }"></b-form-input>

                              <div v-for="(val, index) in errors.epayment_expiry" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <!-- <b-form-group class="col-lg-4 mb-3">
                              <label>Attachment </label>
                              <input class="form-control" type="file"  @change="setFile" accept="image/*" v-bind:class="{ 'is-invalid': Boolean(errors.attachment) }"/>

                              <div v-for="(val, index) in errors.attachment" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>     -->

                           <b-form-group class="col-lg-12 mb-3">
                              <label>Remarks</label>
                              <b-textarea v-model="epayment.remarks" v-bind:class="{ 'is-invalid': Boolean(errors.remarks) }" maxlength="4096"></b-textarea>

                              <div v-for="(val, index) in errors.remarks" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                    
                           
                        </div>                        
                     
                     </b-card>
                     <div class="row mt-3">
                        <div class="12">
                           <button class="btn btn-primary me-2" type="submit">Save</button>
                           <!-- <router-link :to="{ name: 'customers.vehicles', params: { id: contact_id }  }" class="btn btn-light">Cancel</router-link> -->
                           <a href="#" @click.prevent="$router.go(-1)" class="btn btn-light">Cancel</a>
                        </div>
                     </div>
                  </form>   
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
